import React from 'react'
import { FieldLabel } from '../form/index'
import DropOffAreaSearchSelect from './DropOffAreaSearchSelect'

const DropOffAreaSearchSelectField = (props) => (
  <FieldLabel {...props} format={null} component={DropOffAreaSearchSelect} />
)

export default DropOffAreaSearchSelectField
